import React from 'react';
import { NavLink } from 'react-router-dom';

import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import IconStatus from 'components/generic/IconStatus.component';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';

import CN from './NoAccessOverlay.module.scss';

const NoAccessOverlay = ({ trial, unpaid, billingLink }) => (
  <div data-bem="NoAccessOverlay" className={CN.popupAccessOverlay}>
    <div className={CN.container}>
      <div data-bem="NoAccessOverlay__text" className={CN.content}>
        <IconStatus variant="alert" width="lg">
          <Icon variant="alert" width="l1" />
        </IconStatus>

        {fromAnyToBool(!trial) && (
          <div className={CN.flex}>
            <div className={CN.title}>Your free trial has now expired!</div>
            <div className={CN.text}>
              In order to continue using your Slick account, please go to billing and enter your card details to
              activate your monthly subscription.
            </div>
          </div>
        )}

        {fromAnyToBool(unpaid) && (
          <div className={CN.flex}>
            <div className={CN.title}>Looks like there is an outstanding payment on this account</div>
            <div className={CN.text}>
              To resolve, please go to <span className={CN.textBold}>Subscription & Billing</span> and update your card
              details and ensure this has sufficient funds.
            </div>
            <div className={CN.text}>
              Once you have updated your billing details please inform customer support using the
              <span className={CN.textBold}> Live Chat bubble</span> so we can resume your access to Slick.
            </div>
          </div>
        )}

        <NavLink data-bem="NoAccessOverlay__button" to={billingLink}>
          <Button variant="primaryForce" onClick={alwaysNoop} xSpace>
            GO TO ACCOUNT BILLING
          </Button>
        </NavLink>
      </div>
    </div>
  </div>
);

// noinspection JSUnusedGlobalSymbols
export default NoAccessOverlay;
